"use strict";

exports.__esModule = true;
exports.InstantaneousEventController = InstantaneousEventController;
var _react = _interopRequireDefault(require("react"));
var _EventTimelineController = require("../EventTimeline/EventTimelineController");
var _helpers = require("./helpers");
var _excluded = ["devices", "interval", "children"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function InstantaneousEventController(props) {
  var devices = props.devices,
    interval = props.interval,
    children = props.children,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var eventTypes = (0, _helpers.getEventTypes)(extra);
  var start = new Date(interval.startMillis).toISOString();
  var end = new Date(interval.endMillis).toISOString();
  return /*#__PURE__*/_react["default"].createElement(_EventTimelineController.EventTimelineController, {
    eventTypes: eventTypes,
    deviceList: devices,
    start: start,
    end: end
  }, function (_ref) {
    var data = _ref.data;
    return children((0, _helpers.getInstantaneousTimelineEvents)({
      data: data,
      eventTypes: eventTypes
    }));
  });
}